import { toggleStickyHeader } from './sticky-header'
import { isInView } from '../utilities/helpers'
import { throttle } from 'throttle-debounce'

const htmlEl = document.querySelector('html')
const header = document.getElementById('js-site-header')

const modalTriggerSections = document.getElementsByClassName('js-trigger-modal')
  ? Array.from(document.getElementsByClassName('js-trigger-modal'))
  : false

const modalElements = document.getElementsByClassName('js-modal')

const modalCloseEvent = new Event('modalClosed')

/*
|--------------------------------------------------------------------------
| Open Modal
|
| Opens a modal with a specific ID
|--------------------------------------------------------------------------
*/
const openModal = (modalId) => {
  const modal = document.getElementById(modalId)

  if (!modal) {
    return;
  }

  // Open modal
  modal.classList.add('open')
  header?.classList.remove('site-header--sticky')
  htmlEl.classList.add('no-scroll')
  htmlEl.dataset.lenisPrevent = ''

  // Add the close event
  const closeBtn = modal.querySelector('.modal-close')

  modal.addEventListener('click', (e) => {
    const target = e.target

    if (
      target.classList.contains('js-modal') ||
      target.classList.contains('modal-close')
    ) {
      closeModal(modalId)
    }
  })
}

/*
|--------------------------------------------------------------------------
| Close Modal
|
| Closes a modal with a specific ID
|--------------------------------------------------------------------------
*/
const closeModal = (modalId) => {
  const modal = document.getElementById(modalId)

  if (modal) {
    modal.classList.remove('open')

    if (header) {
      toggleStickyHeader()
    }

    htmlEl.classList.remove('no-scroll')

    delete htmlEl.dataset.lenisPrevent
  }

  modal.dispatchEvent(modalCloseEvent)
}

/*
|--------------------------------------------------------------------------
| listenModalSections
|
| The scroll event that will trigger a modal once a specific element is reached.
| Used on gated content blocks to trigger the HubSpot form modals.
|--------------------------------------------------------------------------
*/
const listenModalSections = throttle(75, () => {
  modalTriggerSections.forEach((section) => {
    if (isInView(section)) {
      const modalId = section.dataset.modalId
      const modal = document.getElementById(modalId)

      // Open the modal
      openModal(modalId)

      // Add a close event that adds a class to this section
      modal.addEventListener('modalClosed', () => {
        console.log('test')
        section.classList.add('reveal-form')
      })

      // Remove this item from the array so it only runs once
      const sectionIndex = modalTriggerSections.indexOf(section)
      modalTriggerSections.splice(sectionIndex, 1)
    }
  })

  // If there are no more items, remove the event listener
  if (!modalTriggerSections.length) {
    window.removeEventListener('scroll', listenModalSections)
  }
})

/*
|--------------------------------------------------------------------------
| Init Modal Triggers
|
| Triggers and sets up the various scroll and click events for modals.
|--------------------------------------------------------------------------
*/
const initModalTriggers = () => {
  // Activate scroll events for the gated popups
  if (modalTriggerSections) {
    window.addEventListener('scroll', listenModalSections)
  }

  // Hook up the regular modal link triggers and close buttons
  if (modalElements) {
    Array.from(modalElements).forEach((modal) => {
      const modalId = modal.id ? modal.id : false

      if (!modalId) return

      // Hook up click events on any linsk with a modal ID as the href (<a href="#modal-id">)
      const modalTriggers = document.querySelectorAll(`[href="#${modalId}"]`)

      if (modalTriggers) {
        modalTriggers.forEach((e) => {
          e.addEventListener('click', () => {
            openModal(modalId)
          })
        })
      }
    })
  }
}

export {initModalTriggers, openModal, closeModal}
